import type { Variants } from 'framer-motion';

/**
 * Animation variants for the collapsible content.
 * Provides smooth expand/collapse animation from top to bottom.
 */
export const collapsibleContentVariants: Variants = {
  collapsed: {
    height: 0,
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  expanded: {
    height: 'auto',
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: [0.4, 0, 0.2, 1],
    },
  },
};
